import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Configuration from '@/types/Configuration';
import store from '@/store';

Vue.use(VueI18n);

function getBrowserLocale(options = {}) {
    const defaultOptions = { trimCountryCode: false };
    const opt = { ...defaultOptions, ...options };

    const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

    if (!navigatorLocale) {
        return undefined
    }

    const trimmedLocale = opt.trimCountryCode ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim();

    return trimmedLocale;
}

function getStartingLocale() {
    const storeLocale = store.state.locale;

    if (storeLocale && storeLocale.length > 0) return storeLocale;

    const browserLocale = getBrowserLocale({ trimCountryCode: true });

    if (browserLocale && Configuration.SupportedLocales.includes(browserLocale)) {
        return browserLocale;
    } 
    else {
        return process.env.VUE_APP_I18N_LOCALE || Configuration.DefaultLocale;
    }
}

const i18n = new VueI18n({
    locale: getStartingLocale(),
    fallbackLocale: Configuration.FallbackLocale
});

export default i18n;

